/**
 * MainView React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import {connect} from 'react-redux';
import MainHeader from './MainHeader';
import SideBar from './SideBar';
import ObjectListPage from '../listing/ObjectListPage';
import ObjectEditPage from '../editing/ObjectEditPage';
import MediaUploadPage from '../media/MediaUploadPage';
import AnalyticsPage from '../misc/AnalyticsPage';
import UniKnKubusPage from '../customer/unikn/UniKnKubusPage';
import {
    OBJECT_LIST_PAGE,
    OBJECT_EDIT_PAGE,
    MEDIA_UPLOAD_PAGE,
    ANALYTICS_PAGE,
    CONTROL_PAGE,
    ADMIN_PAGE,
    USER_ACCOUNT_PAGE,
    ABOUT_PAGE,
    UNIKN_KUBUS_PAGE,
    STORYTELLING_PAGE
} from "../../redux/view/consts";
import LoginScreen from "./LoginScreen";
import ControlPage from "../administration/ControlPage";
import AdminPage from "../administration/AdminPage";
import UserAccountPage from "./UserAccountPage";
import AboutPage from "./AboutPage";
import StorytellingPage from '../storytelling/StorytellingPage';


/**
 * MainView provides the side bar plus currently active page
 *
 * @author Jens Gruschel
 */
export class MainView extends React.Component {

    constructor(props) {
        super(props);

        this.menuWidth = 230;
        this.marginLeft = 20;
    }

    /** render header, side bar and current page */
    render() {
        if (!this.props.authorized) {
            return <LoginScreen theme={this.props.theme}/>;
        }
        else {
            return (
                <div>
                    <MainHeader/>
                    <div style={{display: 'flex'}}>
                        <div style={{width: this.menuWidth}}>
                            <SideBar/>
                        </div>
                        <div style={{width: 'calc(100% - ' + this.menuWidth + 'px - ' + this.marginLeft * 2 + 'px)', marginTop: 20, marginLeft: this.marginLeft, marginBottom: 20, marginRight: 20}}>
                            {this.renderCurrentPage()}
                        </div>
                    </div>
                </div>
            );
        }
    }

    /** render page which was selected with OPEN_PAGE action*/
    renderCurrentPage() {
        switch (this.props.currentPage) {

            case OBJECT_LIST_PAGE:
                return <ObjectListPage />;

            case OBJECT_EDIT_PAGE:
                return <ObjectEditPage />;

            case MEDIA_UPLOAD_PAGE:
                return <MediaUploadPage />;

            case ANALYTICS_PAGE:
                return <AnalyticsPage />;

            case CONTROL_PAGE:
                return <ControlPage/>;

            case ADMIN_PAGE:
                return <AdminPage/>;

            case USER_ACCOUNT_PAGE:
                return <UserAccountPage/>;

            case ABOUT_PAGE:
                return <AboutPage/>;

            case UNIKN_KUBUS_PAGE:
                return <UniKnKubusPage/>;

            case STORYTELLING_PAGE:
                return <StorytellingPage/>;

            default:
                // TODO: show error page?
                return <ObjectListPage />;
        }
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.view.currentPage,
        authorized: state.authorization.accessToken !== undefined, // TODO: elaborate!!!
        theme: state.configuration.active.theme
    };
};

export default connect(mapStateToProps, {})(MainView);